import { EntityRoutes } from 'routes/constants';
import strings from 'strings';

export const COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'fullName',
    label: 'Full Name',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.ContactProfile,
          idKey: 'id',
          textKey: 'fullName',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'isOptedOut',
    label: 'Subscription Status',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          label: 'Opt Out',
          presetMode: 'error'
        }
      }
    }
  },
  {
    name: 'email',
    label: 'Email',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'emailVerdict',
    label: 'Email Validation',
    options: {
      sort: false,
      display: true,
      renderer: 'emailStatus'
    }
  },
  {
    name: 'company',
    label: 'Company',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          idKey: 'companyId',
          textKey: 'company',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'companyType',
    label: 'Company Type',
    options: {
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          idKey: 'companyTypeId',
          labelKey: 'companyType',
          baseClass: 'chip-company-type'
        }
      }
    }
  },
  {
    name: 'industry',
    label: 'Industry: Specialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'functionalTitle',
    label: strings.shared.fields.jobFunction,
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'createdAt',
    label: 'Added Date',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'lastActivityDate',
    label: 'Last Activity',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'location',
    label: 'Location',
    options: {
      sort: false,
      display: true
    }
  }
];

export const VIRTUAL_PROPS = [
  {
    propName: 'company',
    attributes: ['companyId', 'company']
  },
  {
    propName: 'companyType',
    attributes: ['companyTypeId', 'companyType']
  },
  {
    propName: 'fullName',
    attributes: ['id', 'fullName']
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'id',
  direction: 'asc'
};
